/** Semantic PNG filenames under /documents/user-manual/images/ (manual figure numbers). */

const USER_MANUAL_IMAGES = '/documents/user-manual/images';

const FIGURE_FILE_BY_NUMBER: Record<number, string> = {
  1: 'prelogin-navigation-bar.png',
  2: 'postlogin-navigation-bar.png',
  3: 'hero-section-and-global-search-bar.png',
  4: 'initiative-by-section-with-logos.png',
  5: 'mahaagx-core-features-section.png',
  6: 'about-section.png',
  8: 'faqs-section.png',
  9: 'call-to-action-and-footer-section.png',
  10: 'click-register-button.png',
  11: 'enter-first-name-last-name-and-email-address.png',
  12: 'creation-of-strong-password.png',
  14: 'verification-link-sent.png',
  15: 'verification-email-received-in-users-inbox.png',
  16: 'postlogin-consumer-dashboard.png',
  17: 'clicking-on-sign-in-button.png',
  18: 'form-for-signing-in.png',
  19: 'postlogin-consumer-dashboard-2.png',
  20: 'clicking-on-forgot-password.png',
  21: 'forgot-password-form.png',
  28: 'accessing-join-organisation-option-from-the-dashboard.png',
  29: 'join-organisation-form.png',
  30: 'selecting-your-organisation.png',
  31: 'entering-job-title-and-employee-id.png',
  32: 'accessing-join-organisation-option-from-the-dashboard-2.png',
  33: 'option-to-add-organisation-when-not-found-in-search.png',
  34: 'organisation-registration-form-organisation-manager-details.png',
  35: 'organisation-registration-form-organisation-details.png',
  36: 'organisation-registration-form-upload-organisation-documents.png',
  37: 'dataset-listing-page.png',
  38: 'sample-search.png',
  39: 'sort-feature.png',
  40: 'filter-options.png',
  41: 'dataset-cards.png',
  42: 'dataset-details.png',
  43: 'dataset-preview.png',
  44: 'dataset-visualization.png',
  45: 'clicking-on-start-adding-dataset.png',
  46: 'set-up-your-dataset.png',
  47: 'adding-metadata-information.png',
  48: 'uploading-data.png',
  49: 'downloading-open-datasets.png',
  50: 'downloading-restricted-datasets.png',
  51: 'copying-dataset-id.png',
  52: 'downloading-dataset-in-ide.png',
  53: 'dataset-downloaded-in-innotebook-interface.png',
  54: 'models-listing-page.png',
  55: 'models-search-bar.png',
  56: 'model-sort-feature.png',
  57: 'models-filter-options.png',
  58: 'model-cards.png',
  59: 'models-detail-page.png',
  60: 'clicking-on-start-adding-model.png',
  61: 'set-up-your-model.png',
  62: 'enter-model-information.png',
  63: 'uploading-model.png',
  64: 'model-download.png',
  75: 'sandbox-ide-section.png',
  76: 'clicking-on-create-new-notebook.png',
  77: 'clicking-on-create-ide-button.png',
  78: 'entering-notebook-information.png',
  79: 'ide-notebook.png',
  80: 'toolsets-section.png',
  81: 'library-section.png',
  82: 'consumer-dashboard.png',
  83: 'my-activities.png',
  84: 'my-projects-section.png',
  85: 'manage-assets-section.png',
  86: 'asset-requests-section.png',
  87: 'manage-users-section.png',
  88: 'user-requests-section.png',
  89: 'manage-assets-section-2.png',
  90: 'asset-requests-section-2.png',
  91: 'role-upgradation-screen.png',
  92: 'my-profile-section.png',
  93: 'faqs-section-2.png',
};

export function getFigureImage(figureNumber: number): string {
  const file = FIGURE_FILE_BY_NUMBER[figureNumber];
  return file ? `${USER_MANUAL_IMAGES}/${file}` : '';
}
